import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { ModalController, NavParams } from '@ionic/angular/standalone';
import { FileUpload, LoadingService, UploadService } from '@scandium-oy/ngx-scandium';
import { AppCommonModule } from 'src/app/common.module';
import { MainDialogComponent } from 'src/app/components/main-dialog/main-dialog.component';

@Component({
  selector: 'app-add-floor-dialog',
  templateUrl: './add-floor.dialog.html',
  styleUrls: ['./add-floor.dialog.scss'],
  imports: [
    AppCommonModule,
    CommonModule,
    MainDialogComponent,
  ],
})
export class AddFloorDialogComponent {
  private formBuilder = inject(FormBuilder);
  private loadingService = inject(LoadingService);
  private _modal = inject(ModalController);
  private navParams = inject(NavParams);
  private uploadService = inject(UploadService);

  existing = this.navParams.get<{ name: string; url: string }>('item');

  formGroup = this.formBuilder.group({
    name: [this.existing?.name ?? '', Validators.required],
    url: [this.existing?.url ?? '', Validators.required],
  });

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  async addBlueprint(event: any) {
    const files = event.target.files as FileList;
    this.loadingService.showLoading();
    for (let file of Array.from(files)) {
      const fileupload = new FileUpload('', file);
      const filename = file.name.split('.')[0];
      fileupload.guid = `${this.navParams.get<string>('site')}-${filename}-${new Date().toISOString()}`;
      const downloadUrl = await this.uploadService.uploadImage(fileupload);
      this.formGroup.get('url').setValue(downloadUrl);
    }
    this.loadingService.hideLoading();
  }

  removeImg() {
    this.formGroup.get('url').setValue('');
  }

  save() {
    const value = this.formGroup.value;
    this._modal.dismiss(value);
  }

  dismiss() {
    this._modal.dismiss();
  }
}
